import { HttpHeaders } from "@angular/common/http";

/**
 * Headers permitidos ao anexar contexto de request/response em eventos do Bugsnag.
 * Playbook de observabilidade (bugsnag §5.5, checklist): scrubbing de PII antes do envio —
 * nunca repassar headers arbitrários (Authorization, Cookie etc.) para ferramentas de erro.
 */
export const ALLOWED_TRACE_HEADERS = [
  "vss-tracing",
  "vss-origin",
  "vss-origin-platform",
  "vss-origin-version",
  "vss-session-id",
  "traceparent",
  "content-type",
] as const;

export const pickAllowedHeaders = (headers: HttpHeaders): Record<string, string> =>
  ALLOWED_TRACE_HEADERS.reduce(
    (acc, key) => {
      const value = headers.get(key);
      if (value) {
        acc[key] = value;
      }
      return acc;
    },
    {} as Record<string, string>,
  );
